<template>
    <div>
      <div v-if="isUserOpenAIKeyEnabledGlobally && useMyOwnApiKey">
        Connected
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not connected
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewApiKey',
    props: [
      'useMyOwnApiKey',
      'isUserOpenAIKeyEnabledGlobally'
    ],
}
</script>

<style lang="scss" scoped>

</style>